export default function TripsHeader() {
  return (
    <div
      className="text-c32 font-semibold text-black222 || pt-12 pb-c20 
      || border-b-c1 border-solid border-gray-300"
    >
      <h1>Trips</h1>
    </div>
  );
}
